import { faLocationDot } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, AlertDescription, AlertTitle } from '@shared/components/ui/shadcn/alert';
import { useTranslation } from 'react-i18next';

export const PackingStationRequiredAlert = () => {
  const { t } = useTranslation('packingModule');

  return (
    <Alert className="mb-4 border-warning/80 bg-bg-warning items-center flex justify-center gap-4">
      <div>
        <FontAwesomeIcon icon={faLocationDot} className="w-5 h-5 !text-warning" />
      </div>
      <div className="flex-1">
        <AlertTitle className="text-warning text-base !mb-0">{t('alerts.packingStationRequired.title')}</AlertTitle>
        <AlertDescription>{t('alerts.packingStationRequired.message')}</AlertDescription>
      </div>
    </Alert>
  );
};
